
import { LoginForm, AuthLayout, RegisterForm } from "modules/Authentication/components";

type Props = {};

const RegisterContainer = (props: Props) => {


  return (
    <AuthLayout>

      <RegisterForm

      />

    </AuthLayout>
  );
};

export default RegisterContainer;
